import i18n from './i18n';

const Utils = {
  formPost(path, params) {
    const form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', path);
    Object.entries(params).forEach(([paramName, paramValue]) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', paramName);
      hiddenField.setAttribute('value', paramValue);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();
    return false;
  },
  listenXHR(callback) {
    let o;
    if (XMLHttpRequest.callbacks) {
      XMLHttpRequest.callbacks.push(callback);
    } else {
      XMLHttpRequest.callbacks = [callback];
      o = XMLHttpRequest.prototype.onload;
      XMLHttpRequest.prototype.onload = function (...args) {
        o.apply(this, args);
        for (let i = 0; i < XMLHttpRequest.callbacks.length; i++) {
          XMLHttpRequest.callbacks[i](this, ...args);
        }
      };
    }
  },
  handleRuleActionCTAClick(rule, openModal) {
    // A. If modal, open modal
    if (rule.action.form && openModal) {
      return openModal(rule);
    }
    // B. default to link
    const link = new URL(rule.action.link);
    if (link.hostname === window.location.hostname) {
      return (window.location.href = link.href);
    }
    return window.open(link.href);
  },
  parseDate(date) {
    Date.prototype.mmmddyyyy = function () {
      const months = [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
      ].map((month) => i18n.t('month', month));

      const m = this.getMonth(); // month zero-based
      const d = this.getDate(); // day 1-based
      const dd = (d > 9 ? '' : '0') + d; // day 1-based - 2 digits

      return i18n.formatDate(dd, months[m], this.getFullYear());
    };

    return new Date(date).mmmddyyyy();
  },
  getErrors(error_) {
    const genericMessage = 'Oops! Something unexpected happened. Please contact the Beans Team.';

    if (!error_) return genericMessage;

    if (error_.error && !error_.detail) error_ = error_.error;

    if (typeof error_.message === 'string') return error_.message;

    if (typeof error_.detail === 'string') return error_.detail;

    const error = { ...error_ };

    try {
      if (error.message) {
        let errorString = '';
        console.log('will start loop');

        for (const key in error.message) {
          if (Object.prototype.hasOwnProperty.call(error.message, key)) {
            console.log(`loop ${key}`);
            const errorLine = error.message[key];
            if (typeof errorLine === 'string') errorString += `${errorLine}\n`;
            else errorString += `${key}: ${errorLine.join()}\n`;
            console.log(errorLine);
          }
        }
        return errorString;
      }
      return error;
    } catch (e) {
      console.log('Oops something unexpected happened. Please contact the Beans Team.');
      return e;
    }
  },
  getCurrentTier(account, display) {
    if (typeof account.tier === 'object') return account.tier;
    const currentTier = display.tiers.find((tier) => tier.id === account.tier);
    return currentTier || null;
  },
  getUrlParam(name) {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },
  parseI18n(strings, data) {
    Object.keys(strings).map((namespace) => {
      if (typeof strings[namespace] === 'object')
        return Object.keys(strings[namespace]).map((key) => {
          return (strings[namespace][key] = i18n.t(namespace, key, data));
        });

      return strings[namespace];
    });

    return strings;
  },
  getI18nData(display, account) {
    const tierNextMilestone = account?.tier?.tier_next_milestone;
    const tierBeans = account?.tier_beans_rolling;
    const stepToMilestone = (tierNextMilestone > tierBeans ? tierNextMilestone : tierBeans) - tierBeans;
    let accountI18n = {};
    let tierI18n = {};

    const displayI18n = {
      beans_name: display.beans_name,
      beans_rate: display.beans_rate,
      points_worth: i18n.printMoney(display.currency.symbol, 1),
      max_discount: display.redemption.max_percentage,
      min_beans: display.redemption.min_beans,
    };

    if (account) {
      accountI18n = {
        beans_balance: account.beans.toLocaleString(),
        beans_value: i18n.printMoney(display.currency.symbol, account.beans_value),
        beans_balance_worth: i18n.printMoney(display.currency.symbol, account.beans_value),
      };

      if (account.tier) {
        tierI18n = {
          current_tier_name: account.tier.name,
          next_tier_name: account.tier.tier_next_name,
          quantity_to_reach_tier: stepToMilestone.toLocaleString(),
          tier_downgrade_milestone: (account.tier.milestone - account.tier_beans_fixed).toLocaleString(),
          tier_expiring_date: `${Utils.parseDate(account.tier_expiring)}`,
          milestone: (account.tier.milestone - account.tier_beans_fixed).toLocaleString(),
        };
      }
    }
    return { ...displayI18n, ...accountI18n, ...tierI18n };
  },
  getRuleAction({ rule, shopperData = {}, account, Strings, display }) {
    const actionLink = rule.settings.cta_link || '';
    const isValidActionLink = actionLink.startsWith('/') || actionLink.includes('://');

    const action = {
      status: null,
      text: rule.settings.cta || Strings.rewards.shop_now,
      link: isValidActionLink ? actionLink : display.website,
      form: null,
    };

    switch (rule.uid) {
      case Utils.LianaRulesUID.NEW_BEANS_CARD:
        action.status = 'completed';
        action.text = Strings.rules.done;
        break;
      case Utils.LianaRulesUID.INSTAGRAM_FOLLOW:
        if (shopperData?.instagram?.processor?.outcome === 'CREDITED') {
          action.status = 'completed';
          action.text = Strings.rules.done;
        } else if (shopperData?.instagram?.instagram_username) {
          action.status = 'action_required';
          action.form = 'action_instagram';
          action.text = Strings.rules.get_points;
        } else {
          action.status = 'auth_required';
          action.form = 'auth_instagram';
          action.text = Strings.rules.follow_us;
        }
        break;
      case Utils.LianaRulesUID.TWITTER_FOLLOW:
        if (shopperData?.twitter?.processor?.outcome === 'CREDITED') {
          action.status = 'completed';
          action.text = Strings.rules.done;
        } else if (shopperData?.twitter?.twitter_username) {
          action.status = 'action_required';
          action.form = 'action_twitter';
          action.text = Strings.rules.get_points;
        } else {
          action.status = 'auth_required';
          action.form = 'auth_twitter';
          action.text = Strings.rules.get_points;
        }
        break;
      case Utils.LianaRulesUID.FACEBOOK_FOLLOW:
        if (shopperData?.facebook?.processor?.outcome === 'CREDITED') {
          action.status = 'completed';
          action.text = Strings.rules.done;
        } else if (shopperData?.facebook?.fb_user_id) {
          action.status = 'action_required';
          action.form = 'action_facebook';
          action.text = Strings.rules.get_points;
        } else {
          action.status = 'auth_required';
          action.form = 'auth_facebook';
          action.text = Strings.rules.get_points;
        }
        break;
      case Utils.LianaRulesUID.TIKTOK_FOLLOW:
        if (shopperData?.tiktok?.processor?.outcome === 'CREDITED') {
          action.status = 'completed';
          action.text = Strings.rules.done;
        } else if (shopperData?.tiktok?.tiktok_username) {
          action.status = 'action_required';
          action.form = 'action_tiktok';
          action.text = Strings.rules.get_points;
        } else {
          action.status = 'auth_required';
          action.form = 'auth_tiktok';
          action.text = Strings.rules.get_points;
        }
        break;
      case Utils.LianaRulesUID.SNAPCHAT_FOLLOW:
        if (shopperData?.snapchat?.processor?.outcome === 'CREDITED') {
          action.status = 'completed';
          action.text = Strings.rules.done;
        } else if (shopperData?.snapchat?.snapchat_username) {
          action.status = 'action_required';
          action.form = 'action_snapchat';
          action.text = Strings.rules.get_points;
        } else {
          action.status = 'auth_required';
          action.form = 'auth_snapchat';
          action.text = Strings.rules.get_points;
        }
        break;
      case Utils.LianaRulesUID.JUDGEME_REVIEWS:
        action.text = Strings.rules.review_product;
        action.link = window.location.origin;
        break;
      case Utils.LianaRulesUID.FRIEND_BEFORE_FIRST_PURCHASE:
      case Utils.LianaRulesUID.REFERRER_AFTER_FIRST_PURCHASE:
        action.text = Strings.rules.refer_friend;
        break;
      case Utils.LianaRulesUID.BIRTHDAY:
        if (account.birthday) {
          action.status = 'completed';
          action.text = Strings.rules.done;
        } else {
          action.status = 'action_required';
          action.form = 'birthday';
          action.text = Strings.rules.set_birthday;
        }
        break;
      default:
        break;
    }

    return { action, ...rule };
  },
  BeansStatusColor: {
    default: { title: '', color: '#666666' },
    loading: { title: 'loading...', color: '#0278D1' },
    done: { title: 'done', color: '#00ab6b' },
    error: { title: 'oops...', color: '#C0392B' },
  },
  LianaRulesUID: {
    NEW_BEANS_CARD: 'rule:liana:new_beans_card',
    INSTAGRAM_FOLLOW: 'rule:liana:instagram_follow',
    TWITTER_FOLLOW: 'rule:liana:twitter_follow',
    FACEBOOK_FOLLOW: 'rule:liana:facebook_follow',
    TIKTOK_FOLLOW: 'rule:liana:tiktok_follow',
    SNAPCHAT_FOLLOW: 'rule:liana:snapchat_follow',
    JUDGEME_REVIEWS: 'rule:liana:judgeme_reviews',
    FRIEND_BEFORE_FIRST_PURCHASE: 'rule:liana:friend_before_first_purchase',
    REFERRER_AFTER_FIRST_PURCHASE: 'rule:liana:referrer_after_first_purchase',
    BIRTHDAY: 'rule:liana:birthday',
  },
  createDOMPromise(setContainerFunction) {
    return new Promise(function (resolve) {
      const action = () => setContainerFunction(resolve);
      const actionWithDelay = () => setTimeout(action, 1000);
      /complete|interactive|loaded/.test(document.readyState)
        ? actionWithDelay()
        : document.addEventListener('DOMContentLoaded', actionWithDelay);
    });
  },

  formatRank(n) {
    if (n % 100 >= 11 && n % 100 <= 13) return `${n}th`;
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const lastDigit = n % 10;
    return `${n}${suffixes[lastDigit] || 'th'}`;
  },

  getScreenWidth() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  },
  convertVIPTiersToArray(tiersObject) {
    if (!tiersObject) return [];

    return Object.keys(tiersObject)
      .filter((key) => key.startsWith('tier_'))
      .map((key) => tiersObject[key])
      .sort((a, b) => a.level - b.level);
  },

  getNextTierMilestone(tiersArray, currentTierLevel) {
    const sortedTiers = tiersArray.slice().sort((a, b) => a.level - b.level);
    return sortedTiers.find((tier) => tier.level > currentTierLevel) || null;
  },

  /**
   * Calculate tier_beans_fixed: beans earned during current tier period
   * @param {Object} account - Account object with tier information
   * @param {Array} transactions - Array of transaction objects with date and beans
   * @returns {number} - Beans earned since tier started
   */
  calculateTierBeansFixed(account, transactions) {
    const tierStartDate = new Date(account.tier_started);
    const now = new Date();

    const tierPeriodTransactions = transactions.filter((transaction) => {
      const transactionDate = new Date(transaction.updated);
      return transactionDate >= tierStartDate && transactionDate <= now && transaction.type === 'deposit';
    });

    const tierBeansFixed = tierPeriodTransactions.reduce((sum, transaction) => {
      return sum + Number(transaction.delta || 0);
    }, 0);

    return tierBeansFixed;
  },
};

export default Utils;
